import React from "react";
import { useRouter } from "next/router";
import poster from "../../public/neet-pg/neetughero.webp";
import axios from "axios";
import Cookies from "js-cookie";

export default function HeroSection() {
  const router = useRouter();

  const [featuresArray, setFeaturesArray] = React.useState([]);
  const [premiumFeaturesArray, setPremiumFeaturesArray] = React.useState([]);
  const [priceBasic, setPriceBasic] = React.useState(null);
  const [pricePremium, setPricePremium] = React.useState(null);

  React.useEffect(() => {
    async function fetchPricing() {
      try {
        const API_URL = process.env.NEXT_PUBLIC_API_URL || "";
        if (!API_URL) return;

        const endpointList = [`${API_URL}/api/fetch-services-data`];

        let res = null;

        for (const endpoint of endpointList) {
          try {
            const response = await axios.get(endpoint);

            if (response?.data?.data?.length > 0) {
              res = response;
              break;
            }
          } catch (error) {
            console.error("API Error:", error);
          }
        }

        if (!res) return;

        if (res?.data?.data?.length > 0) {
          const fetched = res.data.data[0];

          setPriceBasic(
            typeof fetched?.priceDetails?.basic !== "undefined"
              ? fetched.priceDetails.basic
              : null
          );

          setPricePremium(
            typeof fetched?.priceDetails?.premium !== "undefined"
              ? fetched.priceDetails.premium
              : nulln
          );

          const sectionOrder = [
            "tools",
            "analysis",
            "postExamMentorship",
          ];

          const allSections = Object.keys(fetched.features || {}).filter(
            (s) => s !== "lastUpdatedBy" && s !== "_id"
          );

          const orderedSections = [
            ...sectionOrder.filter((s) => allSections.includes(s)),
            ...allSections.filter((s) => !sectionOrder.includes(s)),
          ];

          const arr = [];
          const premiumArr = [];

          orderedSections.forEach((section) => {
            const sectionFeatures = fetched.features[section] || {};

            Object.keys(sectionFeatures).forEach((featureKey) => {
              const featureLabel = String(featureKey)
                .replace(/([a-z])([A-Z])/g, "$1 $2")
                .replace(/[_-]/g, " ")
                .replace(/&/g, " & ")
                .trim();

              if (sectionFeatures?.[featureKey]?.["basic"] === "Yes") {
                arr.push(featureLabel);
              }

              if (sectionFeatures?.[featureKey]?.["premium"] === "Yes") {
                premiumArr.push(featureLabel);
              }
            });
          });

          setFeaturesArray(arr);
          setPremiumFeaturesArray(premiumArr);
        }
      } catch (err) {
        console.error("Fetch Pricing Error:", err);
      }
    }

    fetchPricing();
  }, []);

  const handleGetStarted = (e, tier, price, selectedFeatures) => {
    e.preventDefault();

    const authToken = Cookies.get("authToken");

    const isLoggedIn =
      authToken &&
      authToken !== "undefined" &&
      authToken !== "null" &&
      authToken.trim() !== "";

    if (price === null) {
      alert("Pricing information is not available. Please try again later.");
      return;
    }

    const checkoutQuery = `tier=${encodeURIComponent(
      tier
    )}&price=${encodeURIComponent(
      price
    )}&features=${encodeURIComponent(JSON.stringify(selectedFeatures))}`;

    const checkoutPath = `/checkout?${checkoutQuery}`;

    if (!isLoggedIn) {
      try {
        sessionStorage.setItem(
          "checkoutAfterLogin",
          JSON.stringify({
            tier,
            price,
            features: selectedFeatures,
          })
        );
      } catch (e) {
        console.error(e);
      }

      const loginHost = "https://portal.neetsupport.com";

      const returnUrl = window.location.origin + checkoutPath;

      const loginUrl = `${loginHost}/login?next=${encodeURIComponent(
        returnUrl
      )}`;

      window.location.href = loginUrl;

      return;
    }

    router.push({
      pathname: "/checkout",
      query: {
        tier: tier,
        price: price,
        features: JSON.stringify(selectedFeatures),
      },
    });
  };

  // ✅ FIXED IMAGE SOURCE
  const posterSrc = poster?.src || poster;

  return (
    <section className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-12 relative">
      <div className="bg-[#fff2ed] rounded-2xl p-6 sm:p-10 lg:p-14 flex flex-col lg:flex-row items-center gap-8">
        
        {/* LEFT CONTENT */}
        <div className="w-full lg:w-1/2">
          <h1 className="text-xl sm:text-3xl xl:text-4xl font-extrabold text-gray-900 leading-tight mb-4">
            Find the Best MBBS/BDS/AYUSH Seat Matching{" "}
            <span className="text-[#ff9245]">Your Rank</span>
          </h1>

          <p className="text-base xl:text-lg text-[#6b5f7a] mb-6">
            Powerful tools and experienced mentors to guide your UG journey.
          </p>

          <ul className="mb-6 space-y-3">
            {[
              "AI-powered Cut-off & Allotment Predictor",
              "Detailed Fee, Bond, Stipend & Seat Matrix Across All States",
              "Compare Colleges Side-by-Side with Real Data",
              "Explore 2000+ Institutes with Verified Information",
              "Get Your Doubts Solved in a Personal 1:1 Session",
            ].map((item, index) => (
              <li
                key={index}
                className="flex items-start gap-2 text-gray-800 text-sm xl:text-lg"
              >
                <span className="text-[#ff9245] text-xl">✔</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <div className="mb-6 flex items-center gap-6 flex-wrap">
            <div className="flex flex-col gap-1">
              <div className="flex items-baseline gap-2">
                 <span className="text-sm line-through text-gray-400">₹40000</span>
                <span className="text-2xl font-bold text-[#ff9245]">
                  ₹{pricePremium !== null ? pricePremium : "--"}
                   <span className="text-sm text-gray-600 font-semibold ml-2">+GST</span>
                </span>
               
              </div>
            </div>
            {/* <div className="flex flex-col gap-1">
              <div className="flex items-baseline gap-2">
                <span className="text-sm line-through text-gray-400">₹4999</span>
                <span className="text-lg font-semibold text-[#7a4a24]">
                  Premium ₹{pricePremium !== null ? pricePremium : "--"}
                </span>
              </div>
            </div> */}
          </div>

          <div className="mt-4 flex items-center justify-start gap-4 flex-wrap">
            <button
              onClick={(e) => handleGetStarted(e, "premium", pricePremium, featuresArray)}
              className="inline-flex items-center justify-between gap-1 bg-[#ff9245] text-white pl-6 pr-2 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 active:scale-95 text-xs"
              aria-label="Start Your Counselling Journey"
            >
              <span className="font-semibold text-lg">
                Start Your Journey
              </span>

              <span className="w-6 h-6 bg-white rounded-full flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3 h-3 text-[#ff9245]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2.5}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7 17L17 7M17 7H7M17 7v10"
                  />
                </svg>
              </span>
            </button>

          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="w-full lg:w-1/2 flex justify-center items-center">
          <div className="relative w-full h-80 sm:h-96 md:h-[450px] lg:h-[500px]">
            <img
              src={posterSrc}
              alt="neet pg counselling"
              loading="eager"
              className="object-contain rounded-2xl w-full h-full select-none"
              draggable={false}
            />
          </div>
        </div>
      </div>
    </section>
  );
}